import React, { useState } from 'react';
import Link from 'next/link';
// import dynamic from 'next/dynamic';
import { Button, Box, makeStyles } from '@material-ui/core';
import PropTypes from 'prop-types';

// import FlipPage from 'components/shared/FlipPage';

// const FlipPage = dynamic(() => import('components/shared/FlipPage'), { ssr: false });

const useStyles = makeStyles((theme) => ({
    root: {
        // width: 154,
        height: 200,
        borderRadius: 6,
        backgroundSize: 'cover',
        alignItems: 'end',
        display: 'flex',
        boxShadow: '0px 6px 6px #00000026',
    },
    title: {
        color: 'white',
        height: 39,
        overflow: 'hidden',
        lineHeight: 1.1,
        padding: 10,
        fontSize: 13,
        fontWeight: 500,
        marginBottom: 10,
    },
    titleBG: {
        backgroundColor: 'gray',
        borderRadius: 6,
    },
    bttn: {
        backgroundColor: '#3b546c',
        color: '#94acc3',
        borderRadius: 30,
        padding: '2px 10px',
        margin: 9,
        fontSize: 10,
    },
}));

export const ProjectItem = (props) => {
    const classes = useStyles();
    const [isOpen, setOpen] = useState(false);

    const handleClick = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <>
            <Box className={classes.root} style={{ backgroundImage: `url(${props.image_path})` }}>
                <Box
                    style={{ background: 'linear-gradient(0deg,rgba(0,0,0,.9),rgba(0,0,0,0))' }}
                    className={classes.titleBG}
                >
                    <Link href={`${props.file_path}`} passHref>
                        <a target="_blank">
                            <Box className={classes.title}>{props.title}</Box>
                            {/* <Button className={classes.bttn} onClick={handleClick}>
                                Дэлгэрэнгүй
                            </Button> */}
                        </a>
                    </Link>
                </Box>
            </Box>
            {/* {isOpen ? (
                <FlipPage
                    onClose={handleClose}
                    width={window.outerWidth * 0.8}
                    height={window.outerHeight * 0.8}
                    url={props.file_path}
                />
            ) : (
                ''
            )} */}
        </>
    );
};

ProjectItem.propTypes = {
    name: PropTypes.string,
    onAdd: PropTypes.func,
};

ProjectItem.defaultProps = {
    name: 'hello',
};

export default ProjectItem;
